export { default as Footer } from './Footer';
export * as Styled from './Footer.styles';
